@use '../custom-scroll/custom-scroll' as *;

@layer design-system {
  .backgroundOverlay {
    z-index: var(--z-index-drawer);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: var(--background-backdrop);
    transition: opacity 0.3s ease-out;
    opacity: 0;
  }

  .backgroundOverlayOpen {
    opacity: 0.7;
    top: 0;
  }

  .container {
    width: 600px;
    height: 100%;
    max-height: 100vh;
    display: flex;
    position: fixed;
    right: 0;
    flex-direction: column;
    top: 0;
    z-index: var(--z-index-drawer);
    background-color: var(--background-soft);
    transition: transform 0.3s ease-out;
    transform: translateX(100%);
  }

  .containerOpen {
    transform: translateX(0%);
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    padding: 4px 4px 4px 12px;
  }

  .body {
    @include custom-scroll-minimal;
    flex: 1;
    overflow-y: auto;
    overscroll-behavior-y: contain;
    scroll-behavior: smooth;
  }

  .closeButton {
    padding: 2px 7px;
    height: 32px;
  }
}
